import React from 'react'
import PropTypes from 'prop-types'
import { getClassName, THEMES } from '../../utils/ui'

import { Spinner } from '../'

import './card.component.scss'

/**
 * Card Component
 */
function Card (props) {
  const {
    isLoading, style, className, theme, spinnerTheme, title, headerActions, children, isChin, footNote, footerActions
  } = props

  const hideHeader = !title && (!headerActions || !headerActions.length)
  const hideFooter = !footNote && (!footerActions || !footerActions.length)
  const baseClassName = getClassName('card', [
    { condition: className, trueClassName: className },
    { condition: theme, trueClassName: `card--${theme}` }
  ])
  const headerClassName = getClassName('card_header', [
    { condition: title && headerActions && headerActions.length, trueClassName: 'card_header--justified' }
  ])
  const footerClassName = getClassName('card_footer', [
    { condition: footNote && footerActions && footerActions.length, trueClassName: 'card_footer--justified' }
  ])

  return (
    <article className={baseClassName} style={style}>
      {!hideHeader && (
        <header className={headerClassName}>
          {title && <div>{title}</div>}
          {(headerActions.length > 0) && (
            <div className='card_actions'>{headerActions.map((Action, idx) => <Action key={idx} />)}</div>
          )}
        </header>
      )}

      <section className={`card_children ${isChin ? 'card_children-chin' : ''}`}>
        {isLoading && <Spinner mask theme={spinnerTheme} />}
        {children}
      </section>

      {!hideFooter && (
        <footer className={footerClassName}>
          {footNote && <div>{footNote}</div>}
          {(footerActions.length > 0) && (
            <div className='card_actions'>{footerActions.map((Action, idx) => <Action key={idx} />)}</div>
          )}
        </footer>
      )}
    </article>
  )
}

Card.propsTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  theme: PropTypes.oneOf([THEMES.WHITES, THEMES.DARK_SLATE]),
  spinnerTheme: PropTypes.oneOf([THEMES.RAIN, THEMES.WHITES]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  headerActions: PropTypes.array,
  footNote: PropTypes.string,
  footerActions: PropTypes.array,
  isLoading: PropTypes.bool
}

Card.defaultProps = {
  style: {},
  theme: THEMES.WHITES,
  spinnerTheme: THEMES.RAIN,
  headerActions: [],
  footerActions: []
}

export default Card
